;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="75a73bae-331c-45be-b89f-feea61aa8ce3",e._sentryDebugIdIdentifier="sentry-dbid-75a73bae-331c-45be-b89f-feea61aa8ce3")}catch(e){}}();
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[574],{

/***/ 33121:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login/email",
      function () {
        return __webpack_require__(25152);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Icons_BrimbleLogo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88156);
/* harmony import */ var _components_Micro_TextField__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57923);
/* harmony import */ var _components_Micro_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56425);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82175);
/* harmony import */ var _backend_auth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55263);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _register_email__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5130);
/* harmony import */ var _utils_validation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18702);
/* harmony import */ var _backend__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12901);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _components_Micro_Seo__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(72418);
/* harmony import */ var _layouts_AuthLayout__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(49352);















var LoginWithEmail = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), loading = ref[0], setLoading = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var handleLogin = function(data) {
        setLoading(true);
        (0,_backend_auth__WEBPACK_IMPORTED_MODULE_6__/* .login */ .x4)(data).then(function() {
            return router.push("/login/verification?email=".concat(data.email));
        }).catch(_backend__WEBPACK_IMPORTED_MODULE_10__/* .handleRequestError */ .Yt).finally(function() {
            return setLoading(false);
        });
    };
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        return function() {
            return setLoading(false);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Micro_Seo__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                title: "Login • Email",
                description: "Authenticate with email to continue using Brimble"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_AuthLayout__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center justify-between w-full",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: "text-[40px] text-primary-dark dark:text-white font-semibold w-2/3",
                                            children: "Welcome Back"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-gray-600 dark:text-gray-400 text-sm w-2/3",
                                            children: "Log in with your email to access your dashboard and manage your projects."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_11___default()), {
                                    href: "https://brimble.io",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex items-center justify-center w-16 h-16 rounded-full bg-light dark:bg-theme-color-light",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icons_BrimbleLogo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_5__/* .Formik */ .J9, {
                            initialValues: {
                                email: ""
                            },
                            validationSchema: _utils_validation__WEBPACK_IMPORTED_MODULE_9__/* ["default"].login */ .Z.login,
                            onSubmit: handleLogin,
                            children: function(param) {
                                var errors = param.errors, touched = param.touched, values = param.values, handleChange = param.handleChange, handleBlur = param.handleBlur, handleSubmit = param.handleSubmit;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-full py-10 space-y-2 overflow-x-hidden overflow-y-auto",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Micro_TextField__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            value: values["email"],
                                            error: Boolean(errors["email"]),
                                            helperText: errors["email"],
                                            touched: touched["email"],
                                            type: "email",
                                            onChange: handleChange,
                                            onBlur: handleBlur,
                                            placeholder: "Enter your email address",
                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_register_email__WEBPACK_IMPORTED_MODULE_8__.AuthLabel, {}),
                                            name: "email",
                                            className: "!input-md border-none dark:bg-theme-color-light"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Micro_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            type: "submit",
                                            onClick: function() {
                                                return handleSubmit();
                                            },
                                            loading: loading,
                                            className: "btn-block btn-md !my-5",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-[14px]",
                                                children: "login to your account"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            onClick: function() {
                                                return router.push("/login");
                                            },
                                            className: "mt-5 text-[14px] capitalize btn-link text-primary dark:text-gray-400 btn btn-primary btn-block btn-lg no-underline",
                                            children: "Use other login options"
                                        })
                                    ]
                                });
                            }
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (LoginWithEmail);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5130,9774,2888,179], function() { return __webpack_exec__(33121); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);